import app from '../../../app.js';  
import config from '../../../config.js';  
import Dialog_class from './../../../libs/popup.js';  
import Base_layers_class from './../../../core/base-layers.js';  
import alertify from './../../../../../node_modules/alertifyjs/build/alertify.min.js';  
import Helper_class from './../../../libs/helpers.js'; 
import ImageFilters_class from './../../../libs/imagefilters.js';
  
class Effects_border_class {  
    constructor() {  
        this.POP = new Dialog_class();  
        this.Base_layers = new Base_layers_class();  
        this.Helper = new Helper_class();
        this.ImageFilters = ImageFilters_class;
    }  
  
    Outline() {  
        if (config.layer.type != 'image') {  
            alertify.error('This layer must contain an image. Please convert it to raster to apply this tool.');  
            return;  
        }  
  
        var settings = {  
            title: 'Border',  
            preview: true,  
            params: [  
                {name: "size", title: "Size:", value: 1, range: [0, 20], step: 0.1},  
                {name: "color", title: "Color:", value: "#000000", type: 'color'},
                {name: "alphaTolerance", title: "Alpha Tolerance", value: 0, range: [0,10], step:0.1},
            ],  
            on_change: (params, canvas_preview, w, h) => {  
                var img = canvas_preview.getImageData(0, 0, w, h);  
                var data = this.change(img, params);  
                canvas_preview.putImageData(data, 0, 0);  
            },  
            on_finish: (params) => {  
                this.apply(params);  
            },  
        };  
        this.POP.show(settings);  
    }  
  
    apply(params) {  
        var canvas = this.Base_layers.convert_layer_to_canvas(null, true);  
        var ctx = canvas.getContext("2d");  
        var img = ctx.getImageData(0, 0, canvas.width, canvas.height);  
        var data = this.change(img, params);  
        ctx.putImageData(data, 0, 0);  
        return app.State.do_action(  
            new app.Actions.Update_layer_image_action(canvas)  
        );  
    }  
  
    change(data, params) 
    {  
        const imgData = data.data;  
        const width = data.width;  
        const height = data.height;  
        const size = parseInt(params.size);  
        const color = this.Helper.hexToRgb(params.color);  
        const alphaTolerance = params.alphaTolerance || 10; // New parameter  

        const output = new ImageData(width, height);  
        const outputData = output.data;  

        // Copy original  
        for (var i = 0; i < imgData.length; i += 4) {  
            outputData[i] = imgData[i];  
            outputData[i + 1] = imgData[i + 1];  
            outputData[i + 2] = imgData[i + 2];  
            outputData[i + 3] = imgData[i + 3];  
        }  

        // Detect edges with alpha tolerance  
        for (var y = 0; y < height; y++) {  
            for (var x = 0; x < width; x++) {  
                var idx = (y * width + x) * 4;  

                // Skip if current pixel is below tolerance  
                if (imgData[idx + 3] <= alphaTolerance) continue;  

                // Check neighbors for transparency  
                var hasTransparentNeighbor = false;  
                for (var dy = -size; dy <= size; dy++) {  
                    for (var dx = -size; dx <= size; dx++) {  
                        var nx = x + dx;  
                        var ny = y + dy;  

                        if (nx < 0 || nx >= width || ny < 0 || ny >= height) {  
                            hasTransparentNeighbor = true;  
                            break;  
                        }  

                        var nIdx = (ny * width + nx) * 4;  
                        if (imgData[nIdx + 3] <= alphaTolerance) {  
                            hasTransparentNeighbor = true;  
                            break;  
                        }  
                    }  
                    if (hasTransparentNeighbor) break;  
                }  

                // Draw border pixel if edge detected  
                if (hasTransparentNeighbor) {  
                    outputData[idx] = color.r;  
                    outputData[idx + 1] = color.g;  
                    outputData[idx + 2] = color.b;  
                    outputData[idx + 3] = 255;  
                }  
            }  
        }  

        return output;  
    }
  
    demo(canvas_id, canvas_thumb) {  
        var canvas = document.getElementById(canvas_id);  
        var ctx = canvas.getContext("2d");  
        ctx.drawImage(canvas_thumb, 0, 0);  
          
        var img = ctx.getImageData(0, 0, canvas_thumb.width, canvas_thumb.height);  
        var params = { size: 2, color: "#000000" };  
        var data = this.change(img, params);  
        ctx.putImageData(data, 0, 0);  
    }  
}  
  
export default Effects_border_class;